/**
 * Einen Schluessel fuer das eigene Konto anlegen.
 *
 * Getrennt von `schluessel.ts`, weil das dort rein ist und getestet wird;
 * hier steht der eine Datenbankaufruf. Zwei Seiten legen Schluessel an — die
 * Schluesselseite und der Knopf in der Anleitung auf dem Konto. Beide gehen
 * hier durch, damit Berechtigung und Reihenfolge nicht zweimal stehen.
 *
 * WARUM `simulate`: die MCP-Function verlangt genau diese Berechtigung, ein
 * Schluessel mit `{read,write}` kaeme dort nicht durch (`api_keys_guard`
 * erlaubt beim Anlegen ohnehin nur diese beiden Mengen).
 */

import { ApiFehler } from './api';
import { erzeugeSchluessel } from './schluessel';
import { supabase } from './supabase';
import { melde } from './messung';
import { t } from './sprache';

/** Gibt den Klartext zurueck — erst NACH dem erfolgreichen Einfuegen. */
export async function legeSchluesselAn(kontoId: string, bezeichnung: string): Promise<string> {
  const neu = await erzeugeSchluessel();
  const { error } = await supabase.from('api_keys').insert({
    key_hash: neu.key_hash,
    key_prefix: neu.key_prefix,
    account_id: kontoId,
    label: bezeichnung.trim() || t('Ohne Bezeichnung', 'No label'),
    permissions: ['simulate'],
  });
  // Andersherum stuende ein Klartext auf dem Schirm, den es in der Datenbank
  // nicht gibt.
  if (error) throw new ApiFehler(t(`Der Schlüssel ließ sich nicht anlegen: ${error.message}`, `The key could not be created: ${error.message}`));
  melde({ event: 'key_created' });
  return neu.key;
}
